import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-bootstrap-icons';

import { colors } from '../../../../types/types';

import styles from './MedicosSearch.module.css';

export const MedicosSearch = ({ setSearchString }) => {

  const searchInput = useRef(null);

  const [searchTerm, setSearchTerm] = useState('');

  const [searchValue, setSearchValue] = useState('');

  const handleOnChange = (e) => {
    setSearchValue(e.target.value);
    setSearchTerm(e.target.value);
  }

  const handleClearInput = () => {
    setSearchString("");
    setSearchValue("");
    setSearchTerm("");
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchString(searchTerm);
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  return (
    <div className={styles.FeedbackIconContainer}>
      <input type="text" className={"form-control " + styles.searchInput} value={searchValue} placeholder="Buscar" onChange={handleOnChange} ref={searchInput} />
      <Icon.Search className={styles.FeedbackIcon} color={ colors.INMPUT_FEEDBACK } />
      <Icon.X className={styles.ClearIcon} color={ colors.INMPUT_FEEDBACK } onClick={handleClearInput} size={22} />
    </div>
  )
}

MedicosSearch.propTypes = {
  setSearchString: PropTypes.func.isRequired,
}